import React, {FC} from 'react';
import styled from "styled-components";
import CloseIcon from "../../../media/icons/close.svg?react";

const StatusButton = styled.button<{ $active: boolean; disabled?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: ${({$active}) => $active ? "none" : "1px solid #808080"};
  background-color: ${({$active}) => $active ? "#ff3b30" : "transparent"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({disabled}) => disabled ? "not-allowed" : "pointer"};
  transition: background-color 0.2s ease, border-color 0.2s ease;
  color: ${({$active}) => ($active ? "#ffffff" : "#808080")};
  flex-shrink: 0;
  padding: 0;
  opacity: ${({disabled, $active}) => (disabled && !$active) ? 0.6 : 1};

  svg {
    width: 16px;
    height: 16px;
    
    path {
      fill: currentColor;
    }
  }

  &:hover:not(:disabled) {
    background-color: #e6332a;
    border-color: transparent;
    color: #fff;
    
    svg {
      path {
        fill: #ffffff;
      }
    }
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

interface IDeclineButton {
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export const DeclineButton: FC<IDeclineButton> = ({active = false, onClick, disabled = false}) => {
  return (
    <StatusButton
      type="button"
      $active={active}
      onClick={onClick}
      disabled={disabled}
    >
      <CloseIcon />
    </StatusButton>
  );
};

